module.exports = __webpack_public_path__ + "media/images/gifts/art/sug_arte_8-fcad94ad76aa923ce7580293b7f652d2.jpg";